import React, { type PropsWithChildren } from 'react';
import { StyleSheet, View } from 'react-native';

import { theme } from '@garnish/constants';
import { Container, useResponsive } from '@garnish/core';

import { PARTNER_LINE_ITEM_CONTENT_MAX_WIDTH } from '../../PartnerLineItem.constants';

// ─────────────────────────────────────────────────────────────────────────────

export const PartnerLineItemDetails = (props: PropsWithChildren) => {
  const { children } = props;

  const { match } = useResponsive();

  // ─── Styles ──────────────────────────────────────────────────────────

  const containerStyles = [styles.container, match([styles.containerXS, styles.containerSM])];

  // ─────────────────────────────────────────────────────────────────────

  return (
    <View style={styles.section}>
      <Container style={containerStyles}>{children}</Container>
    </View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  section: {
    alignItems: 'center',
    alignSelf: 'stretch',
  },
  container: {
    maxWidth: PARTNER_LINE_ITEM_CONTENT_MAX_WIDTH,
  },
  containerXS: {
    paddingHorizontal: theme.spacing['6'],
  },
  containerSM: {
    gap: theme.spacing['6'],
    paddingVertical: theme.spacing['10'],
  },
});
